import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Storia from "./StoriaTecnoCard";
import Tecnocard from "./TecnoCard";
import Istruzione from "./IstruzioneTecnoCard";
import Politica from "./PoliticaTecnoCard";
import Tilt from "react-parallax-tilt";

function Tecno() {
  return (
    <>
      {" "}
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.8em", align: "center" }}>
                <strong>ZeroRoleplay</strong> <img 
                  src="https://i.imgur.com/TjHLtdA.png" 
                  style={{ height: "100px" }} 
                /> 
              </h1>
              <Tecnocard />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <Tilt><img src={"https://i.imgur.com/zFFTIvs.png"} alt="about" className="img-fluid" /></Tilt>
            </Col>
          </Row>
          <h1 className="project-heading">
            La mia <strong className="purple">Storia </strong><img 
                  src="https://i.imgur.com/bcT8J0a.png" 
                  style={{ height: "70px"}} 
                /> 
          </h1>

          <Storia />

          <h1 className="project-heading">
            La mia <strong className="purple">Istruzione </strong><img 
                  src="https://i.imgur.com/LQVpw4G.png" 
                  style={{ height: "70px"}} 
                />  
          </h1>
          <Istruzione />

            <h1 className="project-heading">
            Esperienze <strong className="purple">Politiche</strong><img 
                  src="https://i.imgur.com/lDHx9iT.png" 
                  style={{ height: "70px"}} 
                />  
          </h1>
          <Politica />
        </Container>
      </Container>
    </>
  );
}

export default Tecno;
